@defer (when render()) {
    <app-auth-guard>
        <app-center-guard>
            @if (noRole()) {
                <app-no-role />
            } @else {
                <router-outlet />
                <div class="h-[5rem]"></div>
            }
        </app-center-guard>
    </app-auth-guard>
} @placeholder {
    <div class="flex items-center justify-center h-dvh">
        <app-spinner />
    </div>
}
